import { AudienceParcoursStubPage } from '../../../../components/parcours/AudienceParcoursStubPage';
import { getTravauxTertiaireStub } from '../../../../config/travaux-tertiaire';

export default function TertiairePacTertiairePage() {
  const parcours = getTravauxTertiaireStub('pac-tertiaire');
  if (!parcours) return null;
  return (
    <AudienceParcoursStubPage
      parcours={parcours}
      audienceId="tertiaire"
      segment="travaux"
      segmentLabel="Travaux"
      crossLinks={[
        {
          label: 'CEE BAT-* tertiaire',
          href: '/tertiaire/aides/cee-bat',
          iconName: 'sparkles',
          hint: "Prime CEE de base pour la fiche BAT-TH-104",
        },
        {
          label: 'Coup de pouce CVC',
          href: '/tertiaire/aides/coup-de-pouce-cvc',
          iconName: 'flame',
          hint: 'Bonification pour remplacement chaudière fossile',
        },
        {
          label: 'Suramortissement art. 39',
          href: '/tertiaire/aides/suramortissement',
          iconName: 'percent',
          hint: 'Déduction fiscale pour PAC chaleur renouvelable',
        },
      ]}
      crossLinksAllLabel="Voir toutes les aides tertiaire"
      crossLinksAllHref="/tertiaire/aides"
    />
  );
}
